import { render } from "./ClientQuestions.vue?vue&type=template&id=3960438d&scoped=true"
import script from "./ClientQuestions.vue?vue&type=script&lang=js"
export * from "./ClientQuestions.vue?vue&type=script&lang=js"

import "./ClientQuestions.vue?vue&type=style&index=0&id=3960438d&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3960438d"]])

export default __exports__